import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UsageSettingsSaveFailedAction = {
	type: 'USAGE_SETTINGS_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UsageSettingsSaveFailedAction => ({
	type: 'USAGE_SETTINGS_SAVE_FAILED',
	payload,
});
